var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"codeBox"},[_c('h1',[_vm._v(" Here is your iMover Voucher ")]),_c('img',{attrs:{"src":_vm.Imgurl}}),_c('p',[_vm._v(_vm._s(_vm.codeNum))])])}
var staticRenderFns = []

export { render, staticRenderFns }